<template>
	<div>
		<CashdeskControlLayout
			:state="state_key"
			:root="root"
			:cashbook="cashbook"
			:cashdesk="cashdesk"
			:loading-actions="loadingActions"
			:validation-errors="validationErrors"
			:collapsed-components="collapsedComponents"
			:open-cashdesk="openCashdesk"
			:close-cashdesk="closeCashdesk"
			:toggle-select-cash-machine-modal="toggleSelectCashMachineModal"
			:toggle-give-accept-cash-modal="toggleGiveAcceptCashModal"
			:start-cashdesk="startCashdesk"
		/>
		<SelectCashMachineModal
			v-if="state_key.render === 'select_cash_machine_modal'"
			:toggle="toggleSelectCashMachineModal"
			:lookup-cash-machines="lookupCashMachines"
			:open-cashdesk="openCashdesk"
			:loading-actions="loadingActions"
			:generate-cash-machine-code="generateCashMachineCode"
			:show-cash-machine-otp-input="showCashMachineOtpInput"
			:root="root"
		/>
		<GiveAcceptCashModal
			v-if="state_key.render === 'give_accept_cash_modal'"
			:root="root"
			:state="state_key"
			:cashdesk="cashdesk"
			:toggle="toggleGiveAcceptCashModal"
			:default-tab="giveAcceptCashModalDefaulTab"
			:create-cash-to-cashdesk="createCashToCashdesk"
			:confirm-cash-to-cashdesk="confirmCashToCashdesk"
			:create-cash-from-cashdesk="createCashFromCashdesk"
			:pending-orders="pendingIncomingOrders"
			:pending-courier-orders="pendingCourierOrders"
			:cashdesk-closal="giveCashOnCashdeskClosal"
			:loading-actions="loadingActions"
			:validation-errors="validationErrors"
		/>
	</div>
</template>

<script>
import { enum as orderSubTypes } from '@repo/enums/cashbook-order-sub-types';

import CashdeskControlLayout from './cashdesk-control-layout';
import SelectCashMachineModal from './select-cash-machine-modal';
import GiveAcceptCashModal from './give-accept-cash-modal';

export default {
	name: 'CashdeskControl',
	props: {
		root: { type: Object, default: null },
		state_key: { type: Object, default: null },
		cashbook: { type: Object, default: null },
		cashdesk: { type: Object, default: null },
		loadingActions: { type: Array, default: () => [] },
		validationErrors: { type: Array, default: () => [] },
		collapsedComponents: { type: Array, default: () => [] },
		pendingCashbookOrders: { type: Array, default: () => [] },
		openCashdesk: { type: Function, default: null },
		closeCashdesk: { type: Function, default: null },
		toggleSelectCashMachineModal: { type: Function, default: null },
		lookupCashMachines: { type: Function, default: null },
		toggleGiveAcceptCashModal: { type: Function, default: null },
		confirmCashToCashdesk: { type: Function, default: null },
		createCashToCashdesk: { type: Function, default: null },
		createCashFromCashdesk: { type: Function, default: null },
		startCashdesk: { type: Function, default: null },
		giveAcceptCashModalDefaulTab: { type: String, default: null },
		giveCashOnCashdeskClosal: { type: Boolean, default: false },
		showCashMachineOtpInput: { type: Boolean, default: false },
		generateCashMachineCode: { type: Function, default: null }
	},
	components: {
		CashdeskControlLayout,
		SelectCashMachineModal,
		GiveAcceptCashModal
	},
	computed: {
		pendingIncomingOrders() {
			return this.pendingCashbookOrders.filter(
				(o) => o.sub_type === orderSubTypes.cashToCashdesk && o.participant_id === this.cashdesk?.user_id
			);
		},
		pendingCourierOrders() {
			return (
				this.state_key &&
				this.pendingCashbookOrders.filter(
					(o) => o.sub_type === orderSubTypes.cashToCourier && o.participant_id === this.cashdesk?.user_id
				)
			);
		}
	}
};
</script>
